import React from 'react';
import LocationTemplate from './LocationTemplate';

const HobgoodPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Hobgood"
      stateName="North Carolina"
      countyName="Halifax"
      zipCodes={["27843"]}
      latitude={36.0268}
      longitude={-77.4264}
      population={348}
      historicalFact="Incorporated in 1872, developed as a railroad town."
      nearbyTowns={[
        "Scotland Neck, NC",
        "Enfield, NC",
        "Halifax, NC",
        "Hamilton, NC",
        "Robersonville, NC",
        "Oak City, NC",
        "Whitakers, NC",
        "Leggett, NC"
      ]}
    />
  );
};

export default HobgoodPage;